/**
* 数据采集
*/
const collection = {

  addCollectionTerminalClassification: "/api/addCollectionTerminalClassification",//新增终端类别
  modifyCollectionTerminalClassification: "/api/modifyCollectionTerminalClassification",//修改终端类别
  getCollectionTerminalClassifications: "/api/getCollectionTerminalClassifications",//查询终端类别
  deleteCollectionTerminalClassifications: "/api/deleteCollectionTerminalClassifications",//删除终端类别
  addCollectionTerminalParamTemplate: "/api/addCollectionTerminalParamTemplate",//新增终端参数模板
  modifyCollectionTerminalParamTemplate: "/api/modifyCollectionTerminalParamTemplate",//修改终端参数模板
  getCollectionTerminalParamTemplates: "/api/getCollectionTerminalParamTemplates",//查询终端参数模板
  deleteCollectionTerminalParamTemplates: "/api/deleteCollectionTerminalParamTemplates",//删除终端参数模板
  setCollectionTerminalParamTemplateItems: "/api/setCollectionTerminalParamTemplateItems",//设置终端参数模板项
  getCollectionTerminalParamTemplateItems: "/api/getCollectionTerminalParamTemplateItems",//查询终端参数模板项
  addCollectionCenter: "/api/addCollectionCenter",//新增采集中心
  modifyCollectionCenter: "/api/modifyCollectionCenter",//修改采集中心
  getCollectionCenters: "/api/getCollectionCenters",//查询采集中心
  deleteCollectionCenters: "/api/deleteCollectionCenters",//删除采集中心
  addCollectionRepository: "/api/addCollectionRepository",//新增采集数据仓库
  modifyCollectionRepository: "/api/modifyCollectionRepository",//修改采集数据仓库
  getCollectionRepositories: "/api/getCollectionRepositories",//查询采集数据仓库
  // getCollectionRepositories2: "/api/getCollectionRepositories2",//查询采集数据仓库
  deleteCollectionRepositories: "/api/deleteCollectionRepositories",//删除采集数据仓库
  addCollectionTerminal: "/api/addCollectionTerminal",//新增采集终端
  modifyCollectionTerminal: "/api/modifyCollectionTerminal",//修改采集终端
  getCollectionTerminal: "/api/getCollectionTerminal",//查询采集终端
  getCollectionTerminal2: "/api/getCollectionTerminal2",//查询采集终端
  getCollectionTerminal3: "/api/getCollectionTerminal3",//查询采集终端
  getCollectionTerminal4: "/api/getCollectionTerminal4",//查询采集终端
  deleteCollectionTerminals: "/api/deleteCollectionTerminals",//删除采集终端
  listCollectionServices: "/api/listCollectionServices",//查询采集服务
  synchronizeArchiveForCollectionServices: "/api/synchronizeArchiveForCollectionServices",//同步采集档案
  synchronizeArchiveForCollectionServices2: "/api/synchronizeArchiveForCollectionServices2",//同步采集档案

  addCollectionService: "/api/addCollectionService",//增加采系统服务
  modifyCollectionServices: "/api/modifyCollectionServices",//修改采系统服务
  deleteCollectionServices: "/api/deleteCollectionServices",//删除采系统服务

  registerCollectionTerminal: "/api/registerCollectionTerminal",//注册采集终端
}

export default collection